import { useEffect, useState } from 'react';
import { Refresh } from '@mui/icons-material';
import Loading from '../../../../common/loading';
import Table from '../../../../common/table';
import l from '../../../../../lang';
import './styles.scss';
import MessageError from '../../../../common/message-error';
import { usePaymentLink } from '../../../../../store/payment-link';
import StatusIcon from '../../../../common/status-icon';
import CopyToClipboard from 'react-copy-to-clipboard';
import { ReactComponent as CopyIcon } from '../../../../../assets/icons/copy.svg';
import Moment from 'react-moment';
import { useHistory } from 'react-router-dom';
import { PaymentStatus } from '../../../../../constants';
import Tooltip from '@mui/material/Tooltip';
import { ReactComponent as EmptyIcon } from '../../../../../assets/icons/empty-payment-links.svg';
import ButtonLink from '../../../../common/button-link';
import { Routes } from '../../../../../config/routes';
import { segmentPaymentLinkLinkListCopyLink } from '../../../../../utils/analytics';
import { getCountryFlagUrl } from '../../../../../utils';
import { useSelector } from 'react-redux';
import { canViewPaymentLinksTables, canCreatePaymentLinks } from '../../../../../store/payment-link/roles';

const CreatedOneTimePaymentLink = () => {
  const history = useHistory();
  const { auth } = useSelector(state => state);
  const canViewTable = canViewPaymentLinksTables(auth?.roles);
  const canCreate = canCreatePaymentLinks(auth?.roles);

  const [copiedLink, setCopiedLink] = useState<string | null>(null);

  const { createdOneTimePaymentLinks, getCreatedOneTimePaymentLinks } = usePaymentLink();
  const { loading, error, allPaymentLinks } = createdOneTimePaymentLinks;

  useEffect(() => {
    if (canViewTable) {
      getCreatedOneTimePaymentLinks();
    }
  }, [canViewTable]);

  const dataExist = allPaymentLinks && allPaymentLinks?.data?.length > 0;

  return (
    <div className="created_one_time_payment_link">
      {canViewTable && loading && (
        <div className="created_one_time_payment_link__loading">
          <Loading />
        </div>
      )}
      {canViewTable && error && (
        <div className="created_one_time_payment_link__error">
          <MessageError iconClose={<Refresh />} onClose={() => getCreatedOneTimePaymentLinks()} />
        </div>
      )}
      {canViewTable && !loading && !error && (
        <div className="created_one_time_payment_link__table">
          <Table
            dense
            cellAlign="left"
            headers={[
              l('createdPaymentLink.creationDate'),
              l('createdPaymentLink.link'),
              l('createdPaymentLink.country'),
              l('createdPaymentLink.expirationDate'),
              l('createdPaymentLink.description'),
              l('createdPaymentLink.amount'),
              l('createdPaymentLink.paymentStatus'),
            ]}
            emptyBody={
              <div className="created_recurring_payment_link__no_data">
                <EmptyIcon />
                <div className="created_recurring_payment_link__no_data__title">
                  {l('createdPaymentLink.noOneTimePaymentLinks')}
                </div>
                <div>
                  <ButtonLink
                    text={l('createdPaymentLink.noPaymentLinkDesc.1')}
                    onClick={() => history.push(Routes.CREATE_ONE_TIME_PAYMENT_LINK)}
                    disabled={!canCreate}
                  />
                  {l('createdPaymentLink.noPaymentLinkDesc.2')}
                </div>
              </div>
            }
            body={
              (dataExist &&
                allPaymentLinks?.data?.map(pl => [
                  <span>
                    {pl.creationDate ? <Moment format="DD/MM/YYYY">{pl.creationDate}</Moment> : '-'}
                  </span>,
                  <div className="created_one_time_payment_link__copy-cell">
                    {pl.paymentStatus === PaymentStatus.PENDING && pl.paymentLink ? (
                      <CopyToClipboard
                        text={pl.paymentLink}
                        onCopy={() => {
                          segmentPaymentLinkLinkListCopyLink({
                            link: pl.paymentLink,
                          });
                          setCopiedLink(pl.paymentLink);
                        }}
                      >
                        <Tooltip
                          onMouseEnter={() => setCopiedLink(null)}
                          title={l(copiedLink === pl.paymentLink ? 'createdPaymentLink.copiedLink' : 'createdPaymentLink.copyLink')}
                          arrow
                        >
                          <button type="button" className="created_one_time_payment_link__copy-link">
                            <CopyIcon className="created_one_time_payment_link__copy-link-icon" aria-hidden />
                            <span>{l('createdPaymentLink.copyLink')}</span>
                          </button>
                        </Tooltip>
                      </CopyToClipboard>
                    ) : (
                      '-'
                    )}
                  </div>,
                  <span>
                    {pl.country ? (
                      <span className="created_one_time_payment_link__country">
                        <img
                          alt=""
                          className="created_one_time_payment_link__country_flag"
                          src={getCountryFlagUrl(pl.country)}
                        />
                        <span>&nbsp;{pl.country}</span>
                      </span>
                    ) : (
                      '-'
                    )}
                  </span>,
                  <span>
                    {pl.expirationDate ? <Moment format="DD/MM/YYYY">{pl.expirationDate}</Moment> : '-'}
                  </span>,
                  <span>{pl.description || '-'}</span>,
                  <span>{pl.currency && pl.amount ? pl.currency + ' ' + pl.amount : '-'}</span>,
                  <span className="created_one_time_payment_link__status">
                    {(pl.paymentStatus && (
                      <StatusIcon status={pl.paymentStatus} labelKeyPrefix="transactions.status" />
                    )) ||
                      '-'}
                  </span>,
                ])) ||
              null
            }
            rowsPerPageOptions={[10, 25, 50]}
            rowsLength={allPaymentLinks?.totalElements}
            rowsPerPage={allPaymentLinks?.size}
            page={allPaymentLinks?.page}
            handleChangePage={(event, newPage) => getCreatedOneTimePaymentLinks(newPage, allPaymentLinks?.size)}
            handleChangeRowsPerPage={event => getCreatedOneTimePaymentLinks(0, event.target.value)}
            maxHeight={undefined}
          />
        </div>
      )}
    </div>
  );
};

export default CreatedOneTimePaymentLink;
